import { useState, useEffect } from 'react'

const EXCHANGE_RATES: Record<string, number> = {
  USD: 1,
  EUR: 0.92,
  GBP: 0.79,
  MXN: 17.15,
  COP: 4150,
  ARS: 875,
  CLP: 935,
  PEN: 3.72,
  BRL: 4.97,
  UYU: 39.5,
  BOB: 6.91,
  PYG: 7350,
  DOP: 58.5,
  GTQ: 7.82,
  HNL: 24.7,
  NIO: 36.7,
  CRC: 515,
  PAB: 1,
  VES: 36.5,
  CAD: 1.36,
}

const CURRENCY_MAP: Record<string, string> = {
  US: 'USD',
  MX: 'MXN',
  CO: 'COP',
  AR: 'ARS',
  CL: 'CLP',
  PE: 'PEN',
  BR: 'BRL',
  UY: 'UYU',
  BO: 'BOB',
  PY: 'PYG',
  DO: 'DOP',
  GT: 'GTQ',
  HN: 'HNL',
  NI: 'NIO',
  CR: 'CRC',
  PA: 'PAB',
  VE: 'VES',
  EC: 'USD',
  SV: 'USD',
  CA: 'CAD',
  ES: 'EUR',
  GB: 'GBP',
  FR: 'EUR',
  DE: 'EUR',
  IT: 'EUR',
  PT: 'EUR',
}

interface LocalPrice {
  price: string
  originalPrice: string
  currency: string
  loading: boolean
}

export function useLocalPrice(
  usdPrice: number,
  usdOriginalPrice: number,
): LocalPrice {
  const [currency, setCurrency] = useState('USD')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetch('https://ipapi.co/json/')
      .then((res) => res.json())
      .then((data) => {
        const country = data?.country_code || 'US'
        const detected = CURRENCY_MAP[country] || 'USD'
        setCurrency(detected)
      })
      .catch(() => setCurrency('USD'))
      .finally(() => setLoading(false))
  }, [])

  const rate = EXCHANGE_RATES[currency] || 1
  const converted = usdPrice * rate
  const convertedOriginal = usdOriginalPrice * rate

  const format = (value: number) => {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency,
        minimumFractionDigits:
          currency === 'USD' || currency === 'EUR' || currency === 'GBP'
            ? 2
            : 0,
        maximumFractionDigits:
          currency === 'USD' || currency === 'EUR' || currency === 'GBP'
            ? 2
            : 0,
      }).format(value)
    } catch {
      return `$${value.toFixed(2)}`
    }
  }

  return {
    price: format(converted),
    originalPrice: format(convertedOriginal),
    currency,
    loading,
  }
}
